<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 @isShow="isShow" ref="childTab1" />
      </el-tab-pane>
      <el-tab-pane label="审批流转" name="second" :key="'second'" :lazy="true">
        <childTab3 :isShow="isSho" @draftState="draftState" />
      </el-tab-pane>
      <el-tab-pane label="相关文档" name="third" :key="'third'">
        <childTab2 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SuppEditMain from '@/views/MessageManagement/SuppManage/TabChild/SuppEditMain';
import SuppEditAbout from '@/views/MessageManagement/SuppManage/TabChild/SuppEditAbout';
import SuppEditAppr from '@/views/MessageManagement/SuppManage/TabChild/SuppEditAppr';
export default {
  name: 'SuppEdit',
  components: {
    childTab1: SuppEditMain,
    childTab2: SuppEditAbout,
    childTab3: SuppEditAppr
  },
  data() {
    return {
      activeName: 'first',
      isSho: true
    };
  },
  created() {},
  methods: {
    isShow(val) {
      this.isSho = val;
    },
    draftState() {
      this.$refs.childTab1.initData();
    }
  }
};
</script>

<style scoped lang="scss"></style>
